<template>
    <EChart
        :options="chartOptions"
        :error="request.getError()"
        :loading="request.getLoading()"
        type="time"
        card
        class="m-0"
        :header="$t('numberOfOffersInTime')"
    />
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'OffersInTime',
        components: {
            EChart,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData,
            };
        },
        computed: {
            data() {
                return this.parentComponent.data;
            },
            chartSeries() {
                /* eslint-disable no-restricted-syntax, guard-for-in */
                // Agregacja zdarzeń wg kampanii
                const eventsByCampaign = {};

                // Przechodzimy po wszystkich produktach
                Object.values(this.data).forEach(productObj => {
                    const charts = productObj.charts;
                    // Dla każdej grupy (klucza, np. "139", "152" itd.)
                    Object.keys(charts).forEach(chartKey => {
                        charts[chartKey].forEach(chartObj => {
                            const offer = chartObj.offer;
                            const campaign = offer.campaign; // np. "mediaexpert.pl", "euro.com.pl", "MediaMarkt.pl", "Max Elektro.pl"
                            const segments = chartObj.chart.segments;
                            if (segments && segments.length > 0) {
                                segments.forEach(segment => {
                                    if (!eventsByCampaign[campaign]) {
                                        eventsByCampaign[campaign] = [];
                                    }
                                    // Dodajemy zdarzenie startu segmentu (+1)
                                    eventsByCampaign[campaign].push({ time: segment.start, delta: +1 });
                                    // Dodajemy zdarzenie końca segmentu (-1)
                                    eventsByCampaign[campaign].push({ time: segment.end, delta: -1 });
                                });
                            }
                        });
                    });
                });

                // Dla każdej kampanii grupujemy zdarzenia wg czasu, sumujemy deltę i obliczamy wartość skumulowaną
                const series = [];
                for (const campaign in eventsByCampaign) {
                    const events = eventsByCampaign[campaign];
                    // Grupowanie zdarzeń wg tego samego timestampu
                    const groupedEvents = {};
                    events.forEach(event => {
                        if (!groupedEvents[event.time]) {
                            groupedEvents[event.time] = 0;
                        }
                        groupedEvents[event.time] += event.delta;
                    });
                    // Sortujemy czasy rosnąco
                    const times = Object.keys(groupedEvents)
                        .map(t => Number(t))
                        .sort((a, b) => a - b);
                    let cumulative = 0;
                    const dataPoints = [];
                    times.forEach(time => {
                        cumulative += groupedEvents[time];
                        dataPoints.push({ x: time, y: cumulative });
                    });
                    series.push({
                        name: campaign,
                        data: dataPoints,
                    });
                }
                return series;
                /* eslint-enable no-restricted-syntax, guard-for-in */
            },
            chartOptions() {
                const chartData = this.request.getData();
                if (!chartData) {
                    return { series: [] };
                }
                const series = this.chartSeries.map(serie => ({
                    name: serie.name,
                    type: 'line',
                    step: 'end',
                    areaStyle: null,
                    data: serie.data.map(pt => [pt.x, pt.y]),
                }));
                return {
                    xAxis: {
                        type: 'time',
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series,
                };
            },
        },
    };
</script>
